import { createContext as t, useContext as e } from "react";
const r = t(null), p = () => {
  const o = e(r);
  if (o === null)
    throw new Error("Popover components must be wrapped in <MarketPopover />");
  return o;
};
export {
  r as PopoverContext,
  p as default
};
